// Programmatische SEO-pagina's: aftellen tot de besteldeadline, fotowissel bij het
// uitgelichte product en de sticky bestelbalk op mobiel.
(function () {
  if (window.swSeoLoaded) return;
  window.swSeoLoaded = true;

  function daysLeft(until) {
    var end = new Date(until + 'T23:59:59');
    return Math.ceil((end - new Date()) / 864e5);
  }

  function initCountdowns() {
    document.querySelectorAll('[data-sw-until]').forEach(function (el) {
      var d = daysLeft(el.dataset.swUntil);
      if (isNaN(d)) return;
      if (d > 1) el.textContent = 'Nog ' + d + ' dagen om te bestellen';
      else if (d === 1) el.textContent = 'Nog 1 dag om te bestellen';
      else el.textContent = 'Vandaag de laatste dag';
    });
  }

  function initGalleries() {
    document.querySelectorAll('[data-sw-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-sw-main]');
      var thumbs = gallery.querySelectorAll('[data-sw-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          main.src = thumb.dataset.src;
          main.srcset = thumb.dataset.srcset || '';
          main.alt = thumb.dataset.alt || main.alt;
          thumbs.forEach(function (t) {
            t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-sw-sticky]');
    var anchor = document.querySelector('[data-sw-sticky-anchor]');
    if (!bar || !anchor) return;
    var footer = document.querySelector('.footer, footer');
    var ticking = false;
    // Zichtbaar zodra de knoppen in de hero voorbij zijn, weer weg bij de footer.
    function update() {
      ticking = false;
      var pastAnchor = anchor.getBoundingClientRect().bottom < 0;
      var atFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
      bar.classList.toggle('is-visible', pastAnchor && !atFooter);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    initCountdowns();
    initGalleries();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
